<template>
  <v-bottom-sheet
    v-model="LOInfoBottomSheetIsOpen"
    scrollable
  >
    <v-card>
      <v-card-title class="mt-3">
        {{ title }}
      </v-card-title>
      <v-card-text v-html="description" />
    </v-card>
  </v-bottom-sheet>
</template>
<script>
export default {
  name: 'InfoAboutLOBottomSheet',
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
  computed: {
    LOInfoBottomSheetIsOpen: {
      get() {
        return this.isOpen;
      },
      set(newValue) {
        this.$emit('close');
        return newValue;
      },
    },
  },
};
</script>
